import styled from 'styled-components/macro';

import { sizes } from '../../styles/vars';

const Section = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${sizes.pageWidth};
  min-width: ${sizes.pageMinWidth};
  height: 0;
  z-index: 2;
`;

export default Section;
